function add_action(device_category_id = 0, scheme_item_id = 0) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/actions/add',
        onOpen: function (elm, popup) {
            if (device_category_id > 0) {
                elm.find('[name="device_category_id"]').val(device_category_id);
            } else {
                elm.find('[name="device_category_id"]').remove();
            }
            if (scheme_item_id > 0) {
                elm.find('[name="scheme_item_id"]').val(scheme_item_id);
            } else {
                elm.find('[name="scheme_item_id"]').remove();
            }

            elm.find('form').ajaxFormSubmit(function(data){
                popup.close();

                reload_location_if_needed();
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash('Er ging iets mis bij het opslaan.', 'alert');
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function delete_action(id, name) {
    name = decodeURI(name);
    custom_delete_with_confirmation('/actions/delete/' + id, id, 'Weet u zeker dat u "' + name + '" wilt verwijderen?', 'action', false);

    return false;
}
function view_action(id, vars) {
    const $ = jQuery.noConflict();

    if(vars !== undefined && typeof vars === "function") {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: '/actions/view/' + id,
        onOpen: function(elm, popup) {
            elm.find('form').ajaxFormSubmit(function(data){
                if(vars === undefined || vars.callback === undefined) {
                    reload_location_if_needed();
                } else {
                    $('body').doneLoading();
                    vars.callback(data, elm, popup);
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash('Er ging iets mis bij het opslaan.', 'alert');
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}


function load_actions_events(elm) {
    const $ = jQuery.noConflict();
    elm.find('#own_actions')[0].original_value = elm.find('#own_actions').is(':checked');
    elm.find('#own_actions').change(function() {
        elm.find('.actions-wrapper').toggle(elm.find('#own_actions')[0].original_value === $(this).is(':checked'));
    });
}

function get_action(id) {
    const $ = jQuery.noConflict();
    return $.ajax({
        url: '/actions/' + id,
    })
}
